import { get, post, put } from "aws-amplify/api";
import { fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";

const BACKEND_URL = "http://localhost:3001";
const useAmplify = true;

class Api {
  static async getAuthToken() {
    try {
      const session = await fetchAuthSession();
      return session.tokens.accessToken.toString();
    } catch (error) {
      console.error("Error fetching auth token", error);
      throw new Error("User is not authenticated");
    }
  }

  static async get(path, options) {
    const token = await this.getAuthToken();
    if (useAmplify) {
      const restOperation = get({
        apiName: "chatbotApi",
        path,
        options: {
          ...options,
          headers: { Authorization: `Bearer ${token}` },
        },
      });
      const { body } = await restOperation.response;
      return await body.json();
    } else {
      const url = new URL(`${BACKEND_URL}${path}`);
      if (options?.queryParams) {
        Object.keys(options.queryParams).forEach((key) =>
          url.searchParams.append(key, options.queryParams[key])
        );
      }
      const response = await axios.get(url.toString(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    }
  }

  static async post(path, options) {
    const token = await this.getAuthToken();
    if (useAmplify) {
      const restOperation = post({
        apiName: "chatbotApi",
        path,
        options: {
          ...options,
          headers: { Authorization: `Bearer ${token}` },
        },
      });
      const { body } = await restOperation.response;
      return await body.json();
    } else {
      const response = await axios.post(`${BACKEND_URL}${path}`, options.body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    }
  }

  static async put(path, options) {
    const token = await this.getAuthToken();
    if (useAmplify) {
      const restOperation = put({
        apiName: "chatbotApi",
        path,
        options: {
          ...options,
          headers: { Authorization: `Bearer ${token}` },
        },
      });
      const { body } = await restOperation.response;
      return await body.json();
    } else {
      const response = await axios.put(`${BACKEND_URL}${path}`, options.body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    }
  }
}

export default Api;
